import request from '@/plugins/request';

export function GetDataList (data) {
    return request({
        url: '/h5platform/api/houseInfo/listHouseInfoInit',
        method: 'post',
		data:data
    });
}
